import { ClassName, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import BasicFormField from 'components/foundation/form-fields/BasicFormField/BasicFormField';
import { AnyObject } from 'types/util/Object';
import SafetySummaryDashboardListSettings from '../SafetySummaryDashboardListSettings/SafetySummaryDashboardListSettings';
import { TSafetySummaryDashboardListSettingsItem } from '../types/types';

export interface ISafetySummaryDashboardListSettingsFormFieldProps<
  FormType extends { [field: string]: any } = AnyObject,
> extends IFormFieldDefaultProps<TSafetySummaryDashboardListSettingsItem[], FormType> {
  className?: ClassName;
}

export default function SafetySummaryDashboardListSettingsFormField<
  FormType extends { [field: string]: any } = AnyObject,
>({ className, ...fieldProps }: ISafetySummaryDashboardListSettingsFormFieldProps<FormType>) {
  const classes = classNames('safety-summary-dashboard-list-settings-form-field', className);

  return (
    <BasicFormField {...fieldProps} className={classes}>
      {(value, onSelect, _error) => <SafetySummaryDashboardListSettings items={value} onItemsUpdate={onSelect} />}
    </BasicFormField>
  );
}
